import { Checkbox, DropdownMenu } from '../../form';
import { Icon } from '../../UI';
import { VIEWS } from './types';

export function TodaySelector({ setToday, width, setCalendarView }) {
  if (width === 1) {
    return (
      <DropdownMenu
        dropdownClassName={`h-full flex items-center border-r border-grey-10 cursor-pointer`}
        dropdownTooltipClassName={`bg-white border-solid border border-grey-10 -mt-3`}
        dropdownItems={[
          <span className="text-sm" onClick={() => setCalendarView(VIEWS.week)}>
            Week
          </span>,
          <span
            className="text-sm"
            onClick={() => setCalendarView(VIEWS.month)}
          >
            Month
          </span>,
          <span className="text-sm" onClick={setToday}>
            Today
          </span>,
        ]}
        hideOnItemClick
      >
        <Icon svgName="dateBlack" className="dark:text-white" />
      </DropdownMenu>
    );
  }

  return (
    <div
      className="flex items-center justify-center cursor-pointer border-r border-grey-10 dark:border-grey-80"
      onClick={setToday}
    >
      <Icon svgName={width === 1 ? 'dateBlack' : 'dateWithGreenCircle'} />
      {width !== 1 && <span className="font-medium pr-3">Today</span>}
    </div>
  );
}

export function CheckboxWithLabel({ children, onClick, isChecked }) {
  return (
    <>
      {children}
      <Checkbox
        isCheck={isChecked}
        className="text-base"
        onClick={onClick}
        value="test checkbox"
        shape="square"
      />
    </>
  );
}
